import AssignedToRenderer from '@app/modules/Settings/PermissionAssignedToRenderer';
import { type ModifiedColumn } from '@app/store/table/tableSlice';

export const CUSTOM_DATA_INDEX = {
  addNew: 'addNew',
  assignedTo: 'assignedTo',
};

export const TABLE_COLUMNS_PERMISSION_TEMPLATES: ModifiedColumn[] = [
  {
    dataIndex: 'name',
    title: 'Templates',
    key: 'template_name',
    canResize: true,
  },
  {
    dataIndex: 'description',
    title: 'Description',
    key: 'description',
    canResize: true,
  },
  {
    dataIndex: CUSTOM_DATA_INDEX.assignedTo,
    key: 'assigned_to',
    title: 'Assigned To',
    render: (_, record) => (
      <AssignedToRenderer
        usersUuids={record.associated_user_uuids}
        salesGroupIds={record.associated_group_ids}
        roleIds={record.associated_role_ids}
      />
    ),
    canResize: true,
  },
  {
    dataIndex: 'modified_by_name',
    title: 'Modified By',
    key: 'modified_by_name',
    canResize: true,
  },
  {
    dataIndex: 'modified_on',
    title: 'Modified On',
    key: 'modified_on',
    canResize: true,
  },
];

export enum EntityLabel {
  LEADS = 'lead',
  ACTIVITIES = 'activity',
  TASKS = 'task',
  DEALS = 'deal',
}

export enum AllowAccessEntities {
  WORKFLOW = 'workflow',
  REPORT = 'report',
}

export enum ActionType {
  VIEW = 'view',
  CREATE = 'create',
  EDIT = 'edit',
  DELETE = 'delete',
  EXPORT = 'export',
  IMPORT = 'import',
  MARK_COMPLETE = 'mark_complete',
}

export enum EntityAccessLevel {
  NO_ACCESS = 'no_access',
  PARTIAL_ACCESS = 'partial_access',
  FULL_ACCESS = 'full_access',
}

export type RestrictedFields = {
  restricted_fields: string[];
};

export interface Access {
  access: EntityAccessLevel;
  properties?: RestrictedFields | null;
}

export type ActionPermissions = {
  [action in ActionType]: Access;
};

export type EntityPermissions = {
  [entity in EntityLabel]: ActionPermissions;
};

export interface PermissionConfig {
  entity: EntityLabel;
  label: string;
  actions: ActionType[];
  disabledActions: ActionType[];
  partialAccessActions?: ActionType[];
}

export const permissionConfig: PermissionConfig[] = [
  {
    entity: EntityLabel.LEADS,
    label: 'Leads',
    disabledActions: [ActionType.MARK_COMPLETE],
    partialAccessActions: [ActionType.VIEW, ActionType.CREATE, ActionType.EDIT],
  },
  {
    entity: EntityLabel.ACTIVITIES,
    label: 'Activities',
    disabledActions: [ActionType.MARK_COMPLETE],
    partialAccessActions: [ActionType.VIEW, ActionType.CREATE, ActionType.EDIT],
  },
  {
    entity: EntityLabel.TASKS,
    label: 'Tasks',
    disabledActions: [ActionType.IMPORT, ActionType.EXPORT],
    partialAccessActions: [ActionType.VIEW, ActionType.CREATE, ActionType.EDIT],
  },
  {
    entity: EntityLabel.DEALS,
    label: 'Deals',
    disabledActions: [ActionType.IMPORT, ActionType.EXPORT, ActionType.MARK_COMPLETE, ActionType.DELETE],
    partialAccessActions: [],
  },
].map((config) => ({
  ...config,
  actions: Object.values(ActionType).filter((action) => !config.disabledActions.includes(action)),
}));
